module.exports = __webpack_public_path__ + "img/img24.73c6efcb.png";